import type { ReactElement } from 'react';

import { useTranslation } from 'react-i18next';

type ReportFormResultType = {
  isSubmitted: boolean;
};

const ReportFormResult = ({ isSubmitted }: ReportFormResultType): ReactElement => {
  const { t } = useTranslation();
  return (
    <div className={'text-left'}>
      {isSubmitted ? (
        <p className={'d-flex justify-content-center align-items-center p-4'}>
          <span className={'fa fa-check-circle fa-3x d-inline-block mr-3 text-success'}></span>
          {t('photos_ui.report.success.description')}
        </p>
      ) : (
        <p className={'d-flex justify-content-center align-items-center p-4'}>
          <span className={'fa fa-times-circle fa-3x d-inline-block mr-3 text-danger'}></span>
          {t('photos_ui.report.error.general')}
        </p>
      )}
    </div>
  );
};

export default ReportFormResult;
